(function () {
    window.addEventListener('load', function () {

        var NewsSlider = {
            classes: {
                SLIDER_ELEMENT: ".news_carousel__slides .news_carousel__slides_element",
                SLIDER_WRAPPER: ".news_carousel",
                SLIDER: ".news_carousel__slides",
                ARROW_LEFT: ".news_carousel__arrow.is-left",
                ARROW_RIGHT: ".news_carousel__arrow.is-right",
                DISABLED_CLASS: "is-disabled"
            },
            showArrows: function (arrowLeft, arrowRight, totalItems) {
                var DISPLAY_PROP = "flex";
                if (totalItems.length > 3 && window.innerWidth >= 768) {
                    arrowLeft.style.display = DISPLAY_PROP;
                    arrowRight.style.display = DISPLAY_PROP;
                }
            },
            calcSliderWidth: function (element, totalItems, elementWidth) {
                if (totalItems.length > 0) {
                    var totalWidth = totalItems.length * elementWidth + (20 * totalItems.length);
                    element.querySelector(this.classes.SLIDER).style.width = totalWidth + "px";
                }
            },
            getCurrentIndex: function (slider) {
                return parseInt(slider.style.transform.replace("translateX(", '').replace("px)", ''));
            },
            init: function () {
                var sliderWrapper = document.querySelectorAll(this.classes.SLIDER_WRAPPER);
                if (sliderWrapper.length === 0) {
                    return;
                }

                Array.prototype.forEach.call(sliderWrapper, function (element) {
                    var slider = element.querySelector(this.classes.SLIDER);
                    var totalItems = element.querySelectorAll(this.classes.SLIDER_ELEMENT);
                    var arrowLeft = element.querySelector(this.classes.ARROW_LEFT);
                    var arrowRight = element.querySelector(this.classes.ARROW_RIGHT);
                    var elementWidth = totalItems[0].offsetWidth;
                    var currentElement = 3;
                    console.log(currentElement);
                    this.showArrows(arrowLeft, arrowRight, totalItems);
                    this.calcSliderWidth(element, totalItems, elementWidth);

                    arrowRight.addEventListener("click", function () {
                        var nextIndex = this.getCurrentIndex(slider) - (elementWidth + 20);

                        if (currentElement < totalItems.length) {
                            arrowRight.classList.remove(this.classes.DISABLED_CLASS);
                            arrowLeft.classList.remove(this.classes.DISABLED_CLASS);
                            slider.style.transform = "translateX(" + nextIndex + "px)";
                            currentElement += 1;
                        } 

                        if (currentElement === totalItems.length) {
                            arrowRight.classList.add(this.classes.DISABLED_CLASS);
                        }
                    }.bind(this));

                    arrowLeft.addEventListener("click", function () {
                        var nextIndex = this.getCurrentIndex(slider) + (elementWidth + 20);
                        if (nextIndex <= 0) {
                            arrowLeft.classList.remove(this.classes.DISABLED_CLASS);
                            arrowRight.classList.remove(this.classes.DISABLED_CLASS);
                            slider.style.transform = "translateX(" + nextIndex + "px)";
                            currentElement -= 1;
                        } 

                        if (nextIndex === 0) {
                            arrowLeft.classList.add(this.classes.DISABLED_CLASS);
                        }
                    }.bind(this));
                }.bind(this))
            }
        }
        
            NewsSlider.init();
    }, false);
})();